// extracted by mini-css-extract-plugin
export default {"label":"AttributeLabel_label__LXI9D","text":"AttributeLabel_text__NbmjE","checkbox":"AttributeLabel_checkbox__Z--wD"};